import { render, staticRenderFns } from "./EditEmailDialog.vue?vue&type=template&id=6fb45a92"
import script from "./EditEmailDialog.vue?vue&type=script&lang=js"
export * from "./EditEmailDialog.vue?vue&type=script&lang=js"
import style0 from "./EditEmailDialog.vue?vue&type=style&index=0&id=6fb45a92&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports